import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import { styled } from '@mui/system';
import { convertMoney } from '@/utils/convertMoney';
import { style } from '@/styles/globals';
import { pr } from '@/utils/pxToRem';
import WideTableCell from '@/components/WideTableCell';
import FlexTableRow from '@/components/FlexTableRow';
import ShowNoDataDescription from '@/components/ShowNoDataDescription';

const CTABooking = styled('div')`
  ${style.text.content.bold}
  text-align: center;
  color: ${style.color.product3};
  cursor:pointer;
`;

const TableHeader = ['Ngày Tết (âm lịch)', 'Giờ', 'Giá vé Tết rẻ nhất', ' '];

export default function FareInDayNewYear({ days, onSelectTrip }: any) {
  return (
    <TableContainer
      component={Paper}
      sx={{
        minHeight: '50px',
        mt: '8px',
        boxShadow: 'none',
      }}
    >
      <Table
        sx={{ }}
        aria-label="simple table"
      >
        <TableHead>
          <FlexTableRow sx={{
            background: 'white',
            border: 0,
            display: 'flex',
          }}
          >
            {TableHeader.map((label: string, i: number) => (
              <WideTableCell
                key={label}
                sx={{
                  ...(i === 0 ? { whiteSpace: 'nowrap' } : {}),
                }}
                align="center"
              >
                <div
                  dangerouslySetInnerHTML={{ __html: label }}
                />
              </WideTableCell>
            ))}
          </FlexTableRow>
        </TableHead>
        <TableBody>
          { days.length > 0 ? (days || []).map((row: any, i: number) => (
            <FlexTableRow
              key={i.toString()}
              sx={{
                '&:last-child td, &:last-child th': { border: 0 },
                display: 'flex',
              }}
            >
              <WideTableCell align="center">
                <div>
                  {`${row?.dayVN}/${row?.monthVN}`}
                </div>
              </WideTableCell>
              <WideTableCell align="center">
                <div>
                  {row?.pickup_time}
                </div>
              </WideTableCell>
              <WideTableCell
                sx={{ fontWeight: '500' }}
                align="center"
              >
                {row?.averageMinfare ? convertMoney(row?.averageMinfare) : 'Đang cập nhật'}
              </WideTableCell>
              <WideTableCell align="center">
                <div>
                  {row?.airline?.name || 'Đang cập nhật'}
                </div>

              </WideTableCell>
              <WideTableCell align="center">

                {row?.airline?.name && (
                <CTABooking onClick={() => onSelectTrip(row)}>
                  Đặt vé
                </CTABooking>
                )}
              </WideTableCell>
            </FlexTableRow>
          )) : <Box sx={{ p: pr`16px` }}><ShowNoDataDescription /></Box>}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
